import { render, staticRenderFns } from "./VcgProfileUpdateRootComponent.vue?vue&type=template&id=5bb3eac6&scoped=true"
import script from "./VcgProfileUpdateRootComponent.vue?vue&type=script&lang=js"
export * from "./VcgProfileUpdateRootComponent.vue?vue&type=script&lang=js"
import style0 from "./VcgProfileUpdateRootComponent.vue?vue&type=style&index=0&id=5bb3eac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb3eac6",
  null
  
)

export default component.exports